module.exports = __webpack_public_path__ + "media/images/common/sns/line-12ab1e5ca783a4d60622cbd56dac366f.svg";